const ENDPOINTS = {
  LIST_BRANDS: '',
  ADD_BRAND: '/add',
  UPDATE_BRAND: '/update',
  DELETE_BRAND: '/delete',
};

export default ENDPOINTS;